<div class="dialog">
    <h2 mat-dialog-title>{{ data.title }}</h2>
    <div mat-dialog-content>
        <p class="dialog-description">Veuillez saisir votre nouveau mot de passe</p>
        <mat-form-field appearance="outline" class="dialog-field">
            <mat-label>Mot de passe</mat-label>
            <input matInput type="password" [(ngModel)]="data.password">
        </mat-form-field>
        <mat-form-field appearance="outline" class="dialog-field">
            <mat-label>Confirmation</mat-label>
            <input matInput type="password" [(ngModel)]="data.confirmation">
            <mat-icon matSuffix *ngIf="data.password === data.confirmation && data.password.length >= 5" style="color: #4caf50">verified</mat-icon>
            <mat-icon matSuffix *ngIf="data.password !== data.confirmation || data.password.length < 5" style="color: #ff9800">error</mat-icon>
        </mat-form-field>
        <div class="password-hint" *ngIf="data.password !== data.confirmation || data.password.length < 5">
            <mat-icon>info</mat-icon>
            <span>Le mot de passe et la confirmation doivent contenir la même valeur (taille mini 5 caractères)</span>
        </div>
    </div>
    <div mat-dialog-actions align="end">
        <button mat-stroked-button (click)="onNoClick()" *ngIf="data.display === true">Annuler</button>
        <button mat-flat-button color="primary" [mat-dialog-close]="data.password"
                [disabled]="data.password !== data.confirmation || data.password.length < 5" cdkFocusInitial>
            Valider
        </button>
    </div>
</div>